import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-messagemodal',
  templateUrl: './messagemodal.component.html',
  styleUrls: ['./messagemodal.component.scss']
})
export class MessageModalComponent implements OnInit {

  

  ngOnInit() {
  }

  constructor(
    public dialogRef: MatDialogRef<MessageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { text : string, modalParam:any}) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}
